import { FolderItem } from '@workspace/view-model-folder/ui/FolderItem';
import type { Workspace } from '@workspace/domain/workspace/Workspace';
import type { Folder } from '@workspace/view-model-folder/domain/Folder';
import type { RootFolderTree } from '@workspace/view-model-folder/domain/FolderTree';

type Props = {
  folders: Folder[];
  rootFolderTree: RootFolderTree;
  showEditMenu: boolean;
  workspace: Workspace;
};

export const FolderList: React.FC<Props> = ({ folders, rootFolderTree, showEditMenu, workspace }: Props) => {
  return (
    <>
      {folders.map((folder) => {
        return (
          <FolderItem
            key={folder.id}
            showEditMenu={showEditMenu}
            workspace={workspace}
            folder={folder}
            hasChildren={
              rootFolderTree.getFolderIdsOf(folder.id).length + rootFolderTree.getViewModelIdsOf(folder.id).length > 0
            }
          />
        );
      })}
    </>
  );
};
